import React, { useState } from 'react';
import { Card } from "react-bootstrap"
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { useTranslation } from 'react-i18next';
import RolesCard from './RolesCard';
import { ScrollablePane, ScrollbarVisibility } from '@fluentui/react';
import PropTypes from 'prop-types';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';

const ELEMENT_ROLES = (props) => {
	const { 
        inputParam_HideHeader = false,
		inputParam_ComponentContent = null,
    	inputParam_UseFake = false,
		inputParam_BoardStructure = null,
        inputParam_Container = null
    } = props;
	
	const { t } = useTranslation();
	const [roles, setRoles] = useState(!inputParam_UseFake ? inputParam_ComponentContent?.items : [{
		usernames: 'Usuario1',
		rol: 'ADN',
		nRoles: '--'
	},{
		usernames: 'Usuario2',
		rol: 'AAD',
		nRoles: '--'
	},{
		usernames: 'Usuario3',
		rol: 'RF',
		nRoles: '--'
	}]);

	const renderContent = () => {
		return <>
			{
				roles && roles.length > 0 &&
				<ScrollablePane
					styles={{
						root: { height: `100%`, position: "relative" },
						contentContainer:{overflowX: "hidden"}
					}}
					scrollbarVisibility={ScrollbarVisibility.auto}
					scrollContainerFocus={true}
				>
					{
						roles.map((rol, index) => (
							<div key={index} className='m-1'>
								<RolesCard inputParam_ElementItem={rol}/>
							</div>
						))
					}
				</ScrollablePane>
			}
			<NoDataLayer display={ isNullUndefinedOrEmpty(roles) || roles.length === 0 } />
		</>
	}

	return (
	<>
	{
		!inputParam_UseFake &&
		<Card className='board-element-form h-100'>
			{
				!inputParam_HideHeader &&
				<Card.Header className="card-header-compact">
					<Card.Title className="d-flex justify-content-between">
						<b>{(inputParam_ComponentContent && inputParam_ComponentContent.boardComponentTitle) ?? t('data-lang-lbl-roles')}</b>
						<div className='toolbar d-flex'>
							<HEADER_TOOLBAR
								inputParam_BoardStructure={inputParam_BoardStructure}
								inputParam_Container={inputParam_Container}
							/>
						</div>
					</Card.Title>
				</Card.Header>
			}
			<Card.Body className='px-2 pt-2'>
				{renderContent()}
			</Card.Body>
		</Card>
	}
	{ inputParam_UseFake && renderContent() }
	</>
	)
};

ELEMENT_ROLES.propTypes = {
	inputParam_BoardId: PropTypes.number,
	inputParam_GroupDataseriesInOneList: PropTypes.bool,
	inputParam_SetGroupDataseriesInOneList: PropTypes.func,
};

export default ELEMENT_ROLES;